import type { RouteRecordRaw } from 'vue-router'
import { UserSettingsRoutes } from '@/routes/user/settings'
import { getOldRouteWithRedirect } from '@/utils/oldRouteRedirect'

export const userAccountsBillingOverviewRoute: RouteRecordRaw = getOldRouteWithRedirect(
  'user.accounts.billingOverview',
  'billing-overview',
  UserSettingsRoutes.BillingOverview,
)

export const userAccountsMonthlyPlansRoute: RouteRecordRaw = getOldRouteWithRedirect(
  'user.accounts.monthlyPlans',
  'monthly-plans',
  UserSettingsRoutes.BillingPlans,
)

export const userAccountsInvoicesRoute: RouteRecordRaw = getOldRouteWithRedirect(
  'user.accounts.invoices',
  'invoices',
  UserSettingsRoutes.BillingInvoices,
)

export const userAccountsStatementsRoute: RouteRecordRaw = getOldRouteWithRedirect(
  'user.accounts.statements',
  'statements',
  UserSettingsRoutes.BillingStatements,
)
